export const handleApiError = (data, errorMessage, fallbackMsg = "") => {
  if (!errorMessage) {
    return fallbackMsg || "Алдаа гарлаа";
  }
  // Try to find exact match first
  if (data && data[errorMessage]) {
    return data[errorMessage];
  }
  // Return the original error message or default fallback
  return fallbackMsg || "Алдаа гарлаа";
};